import Dropdown from 'react-bootstrap/Dropdown';

export const ItemDropdown = ({ items, item, setItem }) => {

  //const [selectedItem, setSelectedItem] = useState(item);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const currentIndex = items.indexOf(item);
      const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
      const newIndex = (nextIndex + items.length) % items.length;
      setItem(items[newIndex]);
    }
  };

  if (!!!item) return <div>loading ....</div>
  if (!!!items) return <div>loading ....</div>

  return (
    <Dropdown>
      <Dropdown.Toggle id="dropdown-basic-button"
        size="sm"
        variant="secondary"
        onKeyDown={handleKeyDown}>
        {item.name}
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ overflow: 'auto', maxHeight: '80vh' }}>

        {items.map(s => <Dropdown.Item key={s.id} onClick={() => setItem({ ...s })} >{s.name}</Dropdown.Item>)}
      </Dropdown.Menu>
    </Dropdown>
  );
}
